import React, { useEffect, useState } from 'react'
import MainLinks from '../components/navlinks/MainLinks'
import Body from '../components/body/BodyPage'
import { MDBBreadcrumb, MDBBreadcrumbItem } from 'mdb-react-ui-kit'
import { getMisc, getUsersOfGroup } from '../apiclients/streamsapi_bridge';
import { useNavigate } from 'react-router';
import Users from '../components/topviews/Users';
import { useTranslation } from 'react-i18next';

function UsersGroup(props) {
    const [userList, setuserList] = useState([]);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [addUsers, setAddUsers] = useState(false);
    const [sourceUsers, setSourceUsers] = useState([]);
    async function fetchUsersOfGroup() {
        try {
            console.log("[fetchExistingLocations] ");
            const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const groupid = props.groupInfo.usergroup_id;
            console.log("User group id is :::::: "+groupid);
            let serverResponse = await getUsersOfGroup(siteid, groupid);
            if (!serverResponse.json) {
                const message = `An error has occured: ${serverResponse.statusText}`;
                return;
            }
            const rawData = await serverResponse.json();
            if (!rawData) {
                window.alert(`info with id  not found`);
                navigate("/");
            }
            console.log("users group :::::: " + JSON.stringify(rawData));
            setuserList(rawData.members ?? []);

        } catch (error) {
            console.log(`Error in getLocUsers ${error}`);
        }
    }

    async function fetchUsersToAddInGroup() {
        let UserList = [], apiResponse = {};
            apiResponse = await getMisc(JSON.parse(sessionStorage.getItem("admin_session")).siteid, { misc: ["usergroup_users"], usergroup_id: props.groupInfo.usergroup_id });
            console.log(`Hunt Free UserList ::::: ${JSON.stringify(apiResponse)}`);
            if (apiResponse.status === 200) {
                let UsertempList = await apiResponse.json();

                UsertempList = UsertempList.misc.usergroup_users;
                UserList = UsertempList.map(user =>  ({
                    ...user,
                    name: `${user.fname} ${user.lname}`
                  }));
              
                // alert(JSON.stringify(UserList));
                setSourceUsers(UserList);
            } else {
            }
    }
    useEffect(() => {

        if (props?.groupInfo?.usergroup_id) {
            fetchUsersOfGroup();
            fetchUsersToAddInGroup();

        }

    }, [props.groupInfo])
    return (
        <>

            <Users isActive={props.basicActive} addUsers={addUsers} userList={userList} sourceUsers = {sourceUsers} groupUInfo = {props?.groupInfo} />


        </>
    )
}

export default UsersGroup
